'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';

/**
 * Example:
 *   <UnknownName referenceObjectType={WORKFLOW} />
 * Renders as:
 *   Unknown Workflow
 */
import { jsx as _jsx } from "react/jsx-runtime";
const UnknownName = ({
  referenceObjectType
}) => {
  let messageKey = `customerDataReferenceUiComponents.unknownName.${referenceObjectType}`;
  if (!isValidI18nKey(messageKey)) {
    messageKey = 'customerDataReferenceUiComponents.unknownName.default';
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: messageKey
  });
};
export default UnknownName;